import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { LogOut, Bell, Search, Menu } from 'lucide-react';

export default function TopBar({ toggleSidebar }) {
    const { logout, user } = useAuth();

    return (
        <header className="h-16 bg-card/80 backdrop-blur-md border-b border-border sticky top-0 z-10 px-4 md:px-8 flex items-center justify-between">
            <div className="flex items-center gap-4 flex-1">
                {/* Mobile Menu Toggle */}
                <button
                    onClick={toggleSidebar}
                    className="p-2 text-muted-foreground hover:bg-secondary rounded-lg lg:hidden"
                >
                    <Menu size={24} />
                </button>

                {/* Search Bar Placeholder */}
                <div className="relative w-64 hidden sm:block">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                    <input
                        type="text"
                        placeholder="Search..."
                        className="w-full pl-10 pr-4 py-2 bg-secondary rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-ring transition-all"
                    />
                </div>
            </div>

            <div className="flex items-center gap-2 md:gap-4">
                <button className="p-2 text-muted-foreground hover:bg-secondary rounded-full transition-colors relative">
                    <Bell size={20} />
                    <span className="absolute top-1.5 right-1.5 h-2 w-2 bg-red-500 rounded-full border border-card"></span>
                </button>

                <div className="h-6 w-px bg-border mx-1 hidden xs:block"></div>

                <button
                    onClick={logout}
                    className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-muted-foreground hover:text-destructive hover:bg-destructive/5 rounded-lg transition-all"
                >
                    <LogOut size={18} />
                    <span className="hidden xs:inline">Sign Out</span>
                </button>
            </div>
        </header>
    );
}
